import ProtectedRouteHR from './ProtectedRouteHR';
import AddSalesEmployee from 'views/HrDashboard/AddSalesEmployee';
import HRLandingPage from 'views/HrDashboard/HRLandingPage';
import TargetSettings from 'views/HrDashboard/TargetSettings';
import TargetMatrix from 'views/HrDashboard/TargetMatrix';
import Hierarchy from 'views/HrDashboard/Hierarchy';
import CreditLimits from 'views/HrDashboard/CreditLimits';

export const HrRoutes = {
    path: '',
    children: [
        {
            path: 'dashboard',
            element: <ProtectedRouteHR element={<HRLandingPage />} />
        },
        {
            path: 'add-sales-employee',
            element: <ProtectedRouteHR element={<AddSalesEmployee />} />
        },
        {
            path: 'target-settings',
            element: <ProtectedRouteHR element={<TargetSettings />} />
        },
        {
            path: 'target-matrix',
            element: <ProtectedRouteHR element={<TargetMatrix />} />
        },
        {
            path: 'hierarchy',
            element: <ProtectedRouteHR element={<Hierarchy />} />
        },
        {
            path: 'credit-limits',
            element: <ProtectedRouteHR element={<CreditLimits />} />
        }
    ]
};
